export const ADD_PRODUCT = "ADD_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_ARR = "DELETE_ARR";

export const ADD_ISSUANCE_PRODUCT = "ADD_ISSUANCE_PRODUCT";
export const DELETE_ISSUANCE_PRODUCT = "DELETE_ISSUANCE_PRODUCT";
export const DELETE_ISSUANCE_PRODUCT_ARR = "DELETE_ISSUANCE_PRODUCT_ARR";
